import React from 'react';
import styled from 'styled-components';
import { useIsMobile } from '../../hooks/useIsMobile';
import { Text14Medium, TextInfo12 } from '../../mixins/mixins';
import ButtonFeedBack from './ButtonFeedback/ButtonFeedback';
import Navbar from './Navbar/Navbar';
import type { IHeader } from './types';

const HeaderComponent = styled.div<{ isStatic: boolean | undefined }>`
  position: ${props => (props.isStatic ? 'static' : 'fixed')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  background: rgba(28, 99, 255, 1);
  padding: 0 24px;
  z-index: 9999;
  @media (max-width: 669px) {
    padding: 0 12px;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  ${Text14Medium};
  margin-left: 16px;
  @media (max-width: 669px) {
    ${TextInfo12};
    margin-left: 8px;
  }
`;

const Header: React.FC<IHeader> = ({ isVisible, setIsVisible }) => {
    const isMobile = useIsMobile();
    return (
        <HeaderComponent isStatic={isVisible}>
            <HeaderWrapper>
                <img src="/assets/img/HeaderImages/Logo.svg" alt="Logo" />
                <Title>LAOHE</Title>
            </HeaderWrapper>
            {!isMobile && <Navbar />}
            <ButtonFeedBack setIsVisible={setIsVisible} />
        </HeaderComponent>
    );
};

export default Header;
